export default {
  name: 'RecursiveSelector',
  props: ['value', 'options', 'placeholder', 'isAbove', 'singleton'],
  created() {
    window.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.isOpen = false;
      }
    });
  },
  data() {
    return {
      isOpen: false,
      search: '',
      items: this.tierify(this.options),
      currentPosition: 'Raíz',
      content: [], //this.value,
      history: [],
      parent: null,
      back: false,
      fieldPlaceholder: this.placeholder || 'Seleccione un grupo',
    };
  },
  methods: {
    selectItem(e, item) {
      e.stopPropagation();
      if (this.singleton) {
        this.content = [item];
        this.$emit('input', this.content);
        this.toggleDropdown();
      } else {
        if (this.content.filter((elemento) => elemento.id === item.id).length) {
          this.content.splice(
            this.content.findIndex((elemento) => elemento.id === item.id),
            1,
          );
          if (item.childs.length) {
            const childItems = this.getAllSubgroups(item);
            childItems.forEach((child) => {
              this.content.splice(
                this.content.findIndex((elemento) => elemento.id === child.id),
                1,
              );
            });
          }
        } else {
          this.content.push(item);
          if (item.childs && item.childs.length) {
            const childItems = this.getAllSubgroups(item);
            this.content = [...this.content, ...childItems];
          }
        }
        this.content = this.content.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
        this.$emit('input', this.content);
      }
      this.$emit('close');
    },
    selectAllSubgroups(e) {
      e.stopPropagation();
      if (this.parent) this.content.push(this.parent);
      this.sortedItems.forEach((item) => {
        if (!this.content.filter((elemento) => elemento.id === item.id).length) {
          this.content.push(item);
        }
        if (item.childs.length) {
          const childItems = this.getAllSubgroups(item);
          this.content = [...this.content, ...childItems];
        }
      });
      this.content = this.content.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
      this.$emit('input', this.content);
    },
    deselectAllSubgroups(e) {
      e.stopPropagation();
      if (this.parent) {
        if (this.content.filter((elemento) => elemento.id === this.parent.id).length) {
          this.content.splice(
            this.content.findIndex((elemento) => elemento.id === this.parent.id),
            1,
          );
        }
      }
      this.sortedItems.forEach((item) => {
        if (this.content.filter((elemento) => elemento.id === item.id).length) {
          this.content.splice(
            this.content.findIndex((elemento) => elemento.id === item.id),
            1,
          );
        }
        if (item.childs.length) {
          const childItems = this.getAllSubgroups(item);
          childItems.forEach((child) => {
            this.content.splice(
              this.content.findIndex((elemento) => elemento.id === child.id),
              1,
            );
          });
        }
      });
      this.content = this.content.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
      this.$emit('input', this.content);
    },
    goDown(e, item) {
      e.stopPropagation();
      this.history.push(this.items);
      this.items = item.childs;
      this.currentPosition = item.name;
      this.parent = item;
      this.back = true;
    },
    goUp(e) {
      e.stopPropagation();
      this.items = this.history[this.history.length - 1];
      this.history.splice(this.history.length - 1, 1);
      this.back = false;
      if (this.history.length && this.items.length) {
        const parentId = this.items[0].idParent;
        const lastEntry = this.history[this.history.length - 1];
        const parent = lastEntry.find((padre) => padre.id === parentId);
        this.currentPosition = parent.name;
        this.parent;
      } else {
        this.currentPosition = 'Raiz';
        this.parent = null;
      }
    },
    getAllSubgroups(item) {
      let indices = [];
      item.childs.forEach((child) => {
        indices.push(child);
        if (child.childs.length) {
          const childIndices = this.getAllSubgroups(child);
          indices = [...indices, ...childIndices];
        }
      });
      return indices;
    },
    removeTag(index) {
      this.content.splice(index, 1);
      this.$emit('input', this.content);
    },
    tierify(items) {
      if (items.length) {
        return this.getChilds(null, items);
      } else {
        return [];
      }
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        setTimeout(() => this.$refs.searcher.focus(), 100);
      } else {
        setTimeout(() => this.$refs.searcher.blur(), 100);
      }
    },
    getChilds(group, rawData) {
      let groups = [];
      const id = group ? group.id : null;
      if (id) {
        groups = rawData.filter((grupo) => grupo.idParent === id);
      } else {
        groups = rawData.filter((grupo) => !grupo.idParent);
      }
      return groups.map((grupo) => {
        const finalGroup = {
          ...grupo,
          childs: this.getChilds(grupo, rawData),
        };
        if (this.value.filter((groupId) => !isNaN(groupId)).length) {
          this.value.forEach((groupId) => {
            if (groupId === finalGroup.id) {
              this.content.push(finalGroup);
            }
          });
          if (this.content.length === this.value.length) {
            this.$emit('input', this.content);
          }
        }
        return finalGroup;
      });
    },
  },
  computed: {
    sortedItems() {
      if (this.search.length) {
        return this.options.filter((item) => {
          if (this.search.trim().toUpperCase().length) {
            return item.name.toUpperCase().includes(this.search.trim().toUpperCase());
          } else {
            return true;
          }
        });
      } else {
        return this.items.sort((a, b) => {
          if (a.childs.length && !b.childs.length) {
            return -1;
          } else {
            if (!a.childs.length && b.childs.length) {
              return 1;
            }
            return b.id - a.id;
          }
        });
      }
    },
    allSelectedSubgroups() {
      const contentIds = this.content.map((element) => element.id);
      let currentIds = this.sortedItems.map((element) => element.id);
      if (this.parent) currentIds.push(this.parent.id);
      this.sortedItems.forEach((item) => {
        const allSubgroups = this.getAllSubgroups(item);
        const indices = allSubgroups.map((element) => element.id);
        currentIds = [...currentIds, ...indices];
      });
      return currentIds.filter((id) => contentIds.includes(id)).length === currentIds.length;
    },
  },
  watch: {
    options: function (newVal) {
      // watch it
      this.items = this.tierify(newVal);
      this.history = [];
      this.content = [];
      this.parent = null;
      this.currentPosition = 'Raiz';
      this.$emit('input', this.content);
    },
    value: function (newVal) {
      if (newVal.filter((group) => !isNaN(group)).length) {
        this.content = [];
        this.items = this.tierify(this.options);
      }
    },
  },
};
